import { type ChangeEvent, type KeyboardEvent, type ReactNode } from 'react';
import {
    type IFloatingFilterParams,
    type INumberFilterParams,
} from '@ag-grid-community/core';
import { useSearchParams } from 'react-router-dom';
import { useCustomNumberFilter } from './common';

export default function PatternFilter(props: IFloatingFilterParams): ReactNode {
    const { setFilterValue, filterValue } = useCustomNumberFilter(props);
    useSearchParams();

    function onTextChanged(event: ChangeEvent<HTMLInputElement>): void {
        setFilterValue(event.target.value);
    }

    function onKeyDown(event: KeyboardEvent<HTMLInputElement>): void {
        const { key } = event;
        // pass through function and meta keys
        if (key.length > 1) {
            return;
        }
        const allowedCharPattern = (props.filterParams as INumberFilterParams)
            .allowedCharPattern!;
        const regexp = new RegExp(`[${allowedCharPattern}]`);
        if (!regexp.test(key)) {
            event.preventDefault();
        }
    }

    return (
        <div className="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper">
            <input
                className="ag-input-field-input ag-text-field-input"
                type="text"
                value={filterValue ?? ''}
                onChange={onTextChanged}
                onKeyDown={onKeyDown}
            />
        </div>
    );
}
